<div class="shipment-method">
  <div class="row" >
    <div class="col-lg-7 col-md-7 col-sm-7">
      <form [formGroup]="myGroupShipment" *ngIf="myGroupShipment">
        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6">
            <div class="order-type">
              <div>
                <label>{{ "orderCheckOut.incoTermsLbl" | cxTranslate }}</label>

                <ng-select
                  [searchable]="true"
                  [clearable]="false"
                  appendTo="body"
                  class="customer-reference order-checkout-text"
                  formControlName="incoTerms"
                  (change)="onIncoTermsSelect($event, true)"
                >
                  <ng-option
                    *ngFor="let incoTerm of incoTermsArray"
                    [value]="incoTerm.code"
                  >
                    {{ incoTerm.code }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6 mt-3">
            <div>
              <label>{{ "orderCheckOut.freightTermsLbl" | cxTranslate }}</label>

              <ng-select
                [searchable]="true"
                [clearable]="false"
                appendTo="body"
                id="testId"
                formControlName="freightTermsSelect"
                class="hgt32 customer-reference order-checkout-text wdt280"
                (change)="displayFreightAccountNumLogic($event)"
              >
                <ng-option
                  *ngFor="let freightTerms of freightTermsArray"
                  [value]="freightTerms?.code"
                >
                  {{ freightTerms?.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>          
          <!-- [ngClass]="{ hide: freightTermsSelected }" -->
          <div
            class="col-md-6 col-lg-6 col-sm-6 mt-3"
            *ngIf="displayFreightAccountNumber"
          >
            <div class="vs-text-field">
              <label>
                <span class="star"></span>
                {{ "orderCheckOut.freightAccountNumber" | cxTranslate }}</label
              >
              <input
                class="wdt280"
                formControlName="freightAccountNumber"
                [ngClass]="
                  isProceedToCheckout &&
                  (formControls.freightAccountNumber.value == '' ||
                    formControls.freightAccountNumber.value == null)
                    ? 'error'
                    : ''
                "
                [value]="freightAccountNumber"
                (blur)="updateFreightAccountNumber($event.target.value)"
                type="text"
                maxlength="100"
              />

              <label
                #freightAccNoError
                class="error"
                *ngIf="
                  isProceedToCheckout &&
                  (formControls.freightAccountNumber.value == '' ||
                    formControls.freightAccountNumber.value == null)
                "
              >
                {{ "orderCheckOut.freightNoError" | cxTranslate }}
              </label>
            </div>
          </div>          
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6 col-sm-6 mt-3 order-type">
            <div>
              <label
                ><span class="star"></span>
                {{ "orderCheckOut.shipmentMethod" | cxTranslate }}</label
              >

              <ng-select
                class="customer-reference order-checkout-text wdt280"
                formControlName="shipmentMethodSelect"
                [searchable]="true"
                [clearable]="false"
                placeholder='{{ "orderCheckOut.selectPlaceholder" | cxTranslate }}'
                appendTo="body"
                [ngClass]="
                  isProceedToCheckout &&
                  formControls.shipmentMethodSelect.invalid
                    ? 'error-select'
                    : ''
                "
                (change)="onShipmentListSelect($event)"
              >
                <ng-option
                  *ngFor="let shipmentList of shipmentListArray"
                  [value]="shipmentList.code"
                >
                  {{ shipmentList.value }}
                </ng-option>
              </ng-select>

              <label
                #shipmentMethodError
                class="error"
                *ngIf="
                  isProceedToCheckout &&
                  formControls.shipmentMethodSelect.invalid
                "
              >
                {{ "orderCheckOut.shipmentMethodError" | cxTranslate }}
              </label>
            </div>
          </div>
        </div>
        
        <div class="shpinstmrk_container">
          <div class="vs-text-area">
            <label>{{ 'orderCheckOut.shipInstrLbl' | cxTranslate }}</label>
            <textarea
              class="widt613"
              formControlName="shipingInstrctn"
              (change)="onshipingInstrctn($event.target.value)"
              maxlength="255"
            ></textarea>
          </div>
          
          <!-- *ngIf="isMatchFound.length == 0" -->
          <div class="vs-text-area">
            <label>{{ 'orderCheckOut.shipMarksLbl' | cxTranslate }}</label>
            <textarea
              class="widt400"
              formControlName="shipingMarks"
              (change)="onshipingMarks($event.target.value)"
              maxlength="255"
            ></textarea>
          </div>
        </div>   

        <div class="radio-content">
          <strong class="mt-3">{{
            "orderCheckOut.specialInstLbl" | cxTranslate
          }}</strong>

          <div class="special-instructions-warning mt-3">
            <i class='material-icons mr-2'>warning</i>
            <span class="mr-2"><b>{{ "orderCheckOut.warning" | cxTranslate }}:</b></span>
            <span>{{ "orderCheckOut.requireExtraCost" | cxTranslate }}</span>
          </div>

          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
              <div class="vs-checkbox">
                <div
                  *ngFor="let si of specialInstructionData; let i = index"
                  class="instruction"
                >
                  <input
                    [id]="si.code"
                    type="checkbox"
                    name="terms-radio-group"
                    [checked]="si.selected"
                    [(ngModel)]="si.selected"
                    [ngModelOptions]="{ standalone: true }"
                    [value]="si.selected"
                    (click)="updateCheckedOptions($event, si.name)"
                  />
                  <label [for]="si.code">
                    {{ si.name }}
                  </label>

                </div>
              </div>
            </div>

            <div class="vs-text-area ml20" *ngIf="hideTextArea">
              <label>
                <span class="star"></span>
                {{ "orderCheckOut.pleaseSpecify" | cxTranslate }}</label
              >
              <textarea
                required
                [ngClass]="
                  isProceedToCheckout && formControls.shipingInstructions.invalid
                    ? 'error'
                    : ''
                "
                formControlName="shipingInstructions"
                class="widt613"
                (blur)="onshipingInstructions($event.target.value)"
                maxlength="255"
              >
              </textarea>

              <label
                #shipingInstructionsError
                class="error"
                *ngIf="
                  isProceedToCheckout &&
                  formControls.shipingInstructions.invalid
                "
              >
                {{ "orderCheckOut.pleaseSpecifyError" | cxTranslate }}
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- <div class="consolidateLabel" *ngIf="isConsolidatedShipment">
    <span>{{ "orderCheckOut.shipmentMethod" | cxTranslate }}</span>
    <div class="bold">{{ "orderCheckOut.consolidate" | cxTranslate }}</div>
  </div> -->
</div>
